import { api } from "@/lib/apiClient";

// Response types from backend
export interface PendingDealer {
    id: number;
    company: string | null;
    company_legalname: string | null;
    email: string | null;
    phone: string | null;
    website: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
    package: string | null;
    created_at: string;
}

export async function registerPendingDealer(data: {
    email: string;
    password: string;
    company?: string;
    phone?: string;
}): Promise<PendingDealer> {
    const res = await api.post("/dealers/pending/register", data);
    if (!res.data?.ok) throw new Error(res.data?.message || "Registration failed");
    return res.data.dealer as PendingDealer;
}

export async function loginPendingDealer(data: {
    email: string;
    password: string;
}): Promise<PendingDealer> {
    const res = await api.post("/dealers/pending/login", data);
    if (!res.data?.ok) throw new Error(res.data?.message || "Login failed");
    return res.data.dealer as PendingDealer;
}

export async function fetchPendingDealerMe(): Promise<PendingDealer | null> {
    const res = await api.get("/dealers/pending/me");
    return res.data?.dealer ?? null;
}

export async function logoutPendingDealer(): Promise<void> {
    await api.post("/dealers/pending/logout");
}
